var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":{ span: 20, offset: 2 },"lg":{ span: 18, offset: 3 }}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }